import styles from './index.module.sass';

export const AddRangeButton = ({
  onClick,
  label,
}: {
  onClick: () => void;
  label: string;
}) => {
  return (
    <div className={styles.wrap}>
      <a
        className={styles.root}
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        href="#"
      >
        {label}
          <svg
            style={{ transform: 'rotate(45deg)', display: 'inline-block' }}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.75 7.75L12.25 12.25M12.25 7.75L7.75 12.25M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
              stroke="#007E3C"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
      </a>
    </div>
  );
};
